import React, { useEffect, useRef } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const StickyBanner = () => {
  const bannerRef = useRef<HTMLDivElement>(null);
  // Effect to add padding to body when banner is visible
  useEffect(() => {
    const updateBodyPadding = () => {
      if (bannerRef.current) {
        const bannerHeight = bannerRef.current.offsetHeight;
        document.body.style.paddingBottom = `${bannerHeight}px`;
      }
    };
    // Initial update
    updateBodyPadding();
    // Update on resize
    window.addEventListener('resize', updateBodyPadding);
    // Cleanup
    return () => {
      window.removeEventListener('resize', updateBodyPadding);
      document.body.style.paddingBottom = '0';
    };
  }, []);
  return <div ref={bannerRef} className="fixed bottom-0 left-0 w-full bg-[#042A1D] py-4 text-white text-center z-[9999] shadow-lg" style={{
    paddingBottom: 'calc(12px + env(safe-area-inset-bottom))'
  }} role="region" aria-label="Promotion: Save 50% on Drift Today" data-id="element-141">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center justify-center md:gap-4" data-id="element-142">
        {/* Mobile: Stacked layout, Desktop: Row layout */}
        <div className="flex flex-col md:flex-row items-center md:gap-2" data-id="element-143">
          <div className="text-xs md:text-sm font-semibold uppercase tracking-wider mb-1 md:mb-0" data-id="element-144">
            Limited Time Offer:
          </div>
          <div className="text-lg font-bold mb-2 md:mb-0 leading-tight" data-id="element-145">
            Save 50% On Drift™ Today
          </div>
        </div>
        <a href="https://www.thaura.co/products/drift" className="bg-[#84F75D] hover:bg-[#6dd84a] text-black font-bold py-3 px-6 rounded-full flex items-center justify-center min-h-[44px] min-w-[220px] max-w-[90%] mx-auto md:mx-0 focus:outline-none focus:ring-2 focus:ring-white" aria-label="Order Now, Save 50% on Drift Today" data-id="element-146">
          Order Now <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-147" />
        </a>
      </div>
    </div>;
};